import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'PUBLICATION_UPDATE',
    smsDelete : 'PUBLICATION_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : { 
        publication:[],
        publication_count:null,
        publication_category:[],
      
        publication_detail:{},

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        publicationLoading: false,
        publicationError: false,
       
        ...store
    },

    mutations : {
        ...mutations,

        SET_PUBLICATION(state, {results, pg_count}) {
            state.publication = results
            state.publication_count = pg_count
        },

        SET_PUBLICATION_CATEGORY(state, category) {
            state.publication_category = category;
        },

        SET_PUBLICATION_DETAIL(state, detail) {
            state.publication_detail = detail;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },
        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        PUBLICATION_LOADING (state, loading) {
            state.publicationLoading = loading;
        },

        PUBLICATION_ERROR (state, hasError) {
            state.publicationError = hasError;
        } 
    },

    actions: {
        //Publication
        async addPublication ({commit, dispatch}, payload) {
            commit('PUBLICATION_LOADING', true);
            commit('PUBLICATION_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_publication, payload.publication, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPublication',{currentPage:payload.page,perPage:payload.perPage,search_term:payload.search_term})
                return response

            } catch (e) {
                commit('PUBLICATION_ERROR', true);
            } finally {
                commit('PUBLICATION_LOADING', false);
            }
        },

        async fetchPublicationDetail ({ commit },payload) {
            commit('PUBLICATION_LOADING', true);
            commit('PUBLICATION_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_publication_details + payload, config);
                let response = result.data.data
                commit('SET_SLIDER_DETAIL', response);

            } catch(error) {
                commit('PUBLICATION_ERROR', true);
            } finally {
                commit('PUBLICATION_LOADING', false);
            }
        },

        async fetchPublication ({ commit },payload) {
            commit('PUBLICATION_LOADING', true);
            commit('PUBLICATION_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let params = new URLSearchParams();
        
                if (payload.perPage) params.append('count', payload.perPage);
                if (payload.currentPage) params.append('page', payload.currentPage);
                if (payload.category) params.append('category', payload.category);
                if (payload.search_term) params.append('search_term', payload.search_term);
                
                let url = V1API.publication_list + '?' + params.toString();
                let result = await axios.get(url, config);

                const {results, pg_count} = result.data

                commit('SET_PUBLICATION', {results, pg_count});
                return result

            } catch(error) {
                commit('PUBLICATION_ERROR', true);
            } finally {
                commit('PUBLICATION_LOADING', false);
            }
        },

        async fetchPublicationCategory ({ commit }) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.publication_category, config);
                let response = result.data
                commit('SET_PUBLICATION_CATEGORY', response.data);

            } catch(error) {
                commit('SUBMIT_ERROR', true);
            } finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async updatePublication ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_publication+payload.id, payload.publication, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPublication',{currentPage:payload.page,perPage:payload.perPage,search_term:payload.search_term})
                return response

            } catch (e) {
                commit('PUBLICATION_ERROR', true);
            } finally {
                commit('PUBLICATION_LOADING', false);
            }
        },

        
        async deletePublication({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.publication_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchPublication',{currentPage:payload.page,perPage:payload.perPage,search_term:payload.search_term})
            return response
        }
    },

    getters: {}
}
